import { useTranslation } from 'next-i18next';
import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { useRouter } from '@boss/hooks';
import type { Environment, LocalizedSlugs, Navigation } from '@boss/types/corporate-jobs';
import { Container, Footer, Portal, RefreshBanner } from '@boss/ui';

import { Header } from '../components';
import { jobsReferralLink } from '../utils/options';

type Props = {
  children: ReactNode;
  className?: string;
  environment?: Environment;
  localizedSlugs: LocalizedSlugs;
  navigation: Navigation | null;
  preview?: boolean;
};

const Layout = ({
  children,
  className,
  environment = process.env.NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT as Environment,
  localizedSlugs,
  navigation,
  preview,
}: Props) => {
  const isDev = environment !== 'master' || preview;
  const { locale } = useRouter();
  const { t } = useTranslation('common');

  return (
    <>
      {isDev && (
        <Portal>
          <RefreshBanner environment={environment} preview={preview} />
        </Portal>
      )}
      <div className={twMerge(isDev && 'dev-wrapper', 'min-h-[100vh]', className)}>
        <Container className="flex flex-grow flex-col pb-[40px]">
          {navigation && (
            <Header
              localizedSlugs={localizedSlugs}
              mobileMenuClassName={isDev ? 'h-[calc(100vh-100%-3rem)] pb-16' : 'h-[calc(100vh-100%)] pb-16'}
              navigation={navigation}
            />
          )}
          {children}
          {navigation && (
            <Footer
              brandReferralLink={`https://corporate.bosspaints.be/${locale}`}
              legalLinks={navigation.legalLinks}
              locale={locale}
              logo={navigation.footerLogo}
              navigationItems={navigation.footerNavigationItems}
              referralLink={jobsReferralLink}
              socialLinks={navigation.socialLinks}
              socialsLogo={navigation.footerJobsHashtag}
              translations={{
                brand: t('footer.brand'),
                referral: t('footer.referral'),
                referralLinkText: t('footer.referralLinkText'),
                brandReferral: t('footer.brandReferral'),
                brandReferralLinkText: t('footer.brandReferralLinkText'),
              }}
            />
          )}
        </Container>
      </div>
    </>
  );
};

export default Layout;
